<template>
  <div class="antialiased">
    <Sidebar/>
    <div class="page">
      <Header hint="Ketik no. invoice" @change="_search"/>

      <div class="content">
        <div class="container">
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">
                  STT Enhanced
                </h2>
              </div>

              <div class="col-auto">
                <div class="row">
                  <div class="col-auto px-0">
                    <div class="input-icon">
                      <span class="input-icon-addon">
                        <i class="fe fe-align-left"></i>
                      </span>
                      <select
                        class="form-control"
                        v-model="paginate.peribuanage"
                        @change="_get"
                        :disabled="loading"
                      >
                        <option
                          :value="num"
                          v-for="(num, i) in [10, 50, 100, 9999]"
                          :key="i"
                          v-html="num == 9999 ? 'Semua' : num"
                        />
                      </select>
                    </div>
                  </div>

                  <div class="col-auto" style="padding-right: 0px;">
                    <button
                      class="btn btn-danger"
                      v-html="ic('trash')"
                      @click="_deleteImport"
                    ></button>
                  </div>

                  <div class="col-auto btn-group">
                    <button
                      class="btn btn-white"
                      v-html="ic('filter')"
                      @click="_filter"
                    ></button>
                    <button
                      class="btn btn-outline-primary"
                      @click="_export"
                      :disabled="isExportRequest || data.length == 0" 
                      v-html="isExportRequest ? spin() : 'Export'"
                    ></button>
                    <button 
                      class="btn btn-primary " 
                      @click="_import"
                      v-html="'Import'"
                    ></button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Skeleton
            type="table"
            :length="10"
            class="mt-3 bg-white"
            v-if="loading"
          />

          <Nodata v-if="!loading && data.length == 0" />

          <div class="box" v-if="!loading && data.length > 0">
            <div class="card">
              <div class="table-responsive">
                <table
                  class="table table-vcenter table-hover card-table table-striped table-control"
                >
                  <thead>
                    <tr class="text-muted">
                      <th>Order</th>
                      <th>Toko</th>
                      <th>Depo</th>
                      <th>Salesman</th>
                      <th>Barang</th>
                      <th>Qty</th>
                      <th>Total</th>
                      <th class="text-center">Tgl Deliv</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(row, i) in data" :key="i">
                      <td>
                        {{ row.nopo }} <br> {{ row.number }}
                      </td>
                      <td>
                        {{ row.outcode }} <br> {{ row.outname }}
                      </td>
                      <td>
                        {{ row.depo }}
                      </td>
                      <td>
                        {{ row.team }} <br> {{ row.slsmname }}
                      </td>
                      <td>
                        {{ row.scode }}
                      </td>
                      <td>
                        {{ row.qtydus }} / {{ row.qtypcs }}
                      </td>
                      <td>
                        {{ row.total|currency }}
                      </td>
                      <td nowrap style="vertical-align: center">
                        <ul style="list-style-type: none; margin-top: 10px">
                          <li v-if="row.delivered_at != ''">
                            <span title="Tanggal Delivered" class="btn btn-sm btn-info" v-html="row.delivered_at" />
                          </li>
                        </ul>
                      </td>
                      <td>
                        <span v-html="row.status" class="badge w-100" :class="statusClass[row.status]" />
                      </td>
                      <td class="p-0 pos-relative">
                        <div class="btn-group option center">
                          <button
                            class="btn btn-white btn-pill"
                            @click="_delete(row.id)"
                            v-html="ic('trash')"
                          ></button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <b-pagination
            v-if="data.length > 0 && !loading"
            align="center"
            class="mt-5"
            :total-rows="paginate.totalRows"
            v-model="paginate.currentPage"
            :per-page="paginate.peribuanage"
            @change="_pageChange"
          />
        </div>
      </div>
    </div>

    <FormImport
      :config.sync="formImport.config"
      :initData="formImport.data"
      :dismiss.sync="formImport.dismiss"
      :isSubmit.sync="formImport.isSubmit"
      @submit="formImport.action" />

    <FormDelete
      :config.sync="formDelete.config"
      :initData="formImport.data"
      :dismiss.sync="formDelete.dismiss"
      :isSubmit.sync="formDelete.isSubmit"
      @submit="formDelete.action" />

    <Confirm
      :id.sync="confirm.id"
      :title.sync="confirm.title"
      :isSubmit.sync="confirm.isSubmit"
      @submit="confirm.action"
    />

    <FormFilter
      :config.sync="filter.config"
      :initData="filter.data"
      :dismiss.sync="filter.dismiss"
      :isSubmit.sync="filter.isSubmit"
      @submit="filter.action"
    />
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import FormImport from "./modals/form-import.vue";
import FormDelete from "./modals/form-delete.vue";
import FormFilter from "./modals/filter.vue";

const now = new Date();
export default {
  name: "SttEnhanced",
  components: { FormImport, FormDelete, FormFilter },
  data() {
    return {
      loading: true,
      data: [],
      paginate: {
        currentPage: 1,
        totalRows: 0,
        peribuanage: 10,
        fromPage: 0,
      },

      statusClass: {
        waiting: "bg-orange",
        approved: "bg-green",
        loaded: "bg-info",
        delivered: "bg-info",
        closed: "bg-danger",
        cancel: "bg-danger",
        reject: "bg-danger",
      },

      formImport: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => { },
      },

      formDelete: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => { },
      },

      isExportRequest: false,

      confirm: {
        id: null,
        title: null,
        isSubmit: false,
        action: () => {},
      },

      filter: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => {},
      },

      dataFilter: {
        keyword: "",
        id_perusahaan: "",
        id_salesman: "all",
        start_date: new Date(now.getFullYear(), now.getMonth() - 3, now.getDate()+ 1).toISOString().slice(0, 10),
        end_date: this.dateTime("ymd"),
        status: "all",
        ids_depo: [],
        id_import: '',
      },
    }
  },

  mixins: [helper],

  methods: {
    _get(params) {
      this.loading = params == null ? true : !params.silent;

      let filter = {
        id_import: this.dataFilter.id_import,
        keyword: this.dataFilter.keyword,
        id_perusahaan: this.dataFilter.id_perusahaan,
        id_salesman: this.dataFilter.id_salesman,
        ids_depo: this.dataFilter.ids_depo,
        start_date: this.dataFilter.start_date,
        end_date: this.dataFilter.end_date,
        status: this.dataFilter.status,
        per_page: this.paginate.peribuanage,
        page: this.paginate.currentPage,
      };

      this.axios
        .get("/external_app/stt_enhanced", { params: filter })
        .then((res) => {
          this.loading = false;

          this.paginate.totalRows = res.data.meta.total;
          this.paginate.fromPage = res.data.meta.from;
          this.data = res.data.data;
        })
        .catch((err) => {
          this.loading = false;
          this.onError(err);
        });
    },

    _pageChange(page) {
      this.paginate.currentPage = page;
      this._get();
    },

    _search(keyword) {
      this.dataFilter.keyword = keyword;
      this._get();
    },

    _export() {
      this.isExportRequest = true;

      let filter = {
        id_perusahaan: this.dataFilter.id_perusahaan,
        id_salesman: this.dataFilter.id_salesman,
        start_date: this.dataFilter.start_date,
        end_date: this.dataFilter.end_date,
        status: this.dataFilter.status,
        keyword: this.dataFilter.keyword,
      };
      this.axios.get("external_app/stt_enhanced", { params: filter })
        .then((res) => {
          this.isExportRequest = false;
          const dataExcel = res.data.data.map((stt) => ({
            gudang: stt.gudang,
            outcode: stt.outcode,
            outname: stt.outname,
            address: stt.address,
            kab: stt.kab,
            kecamatan: stt.kecamatan,
            kelurahan: stt.kelurahan,
            kodepos: stt.kodepos,
            npwp: stt.npwp,
            custtype: stt.custtype,
            typeotl: stt.typeotl,
            distrik: stt.distrik,
            itemcode: stt.itemcode,
            scode: stt.scode,
            groupcode: stt.groupcode,
            brand: stt.brand,
            segmen: stt.segmen,
            satuan: stt.satuan,
            slsmname: stt.slsmname,
            team: stt.team,
            depo: stt.depo,
            qtydus: stt.qtydus,
            qtypcs: stt.qtypcs,
            hargatrans: parseFloat(stt.hargatrans),
            volume: stt.volume,
            tahun: stt.tahun,
            bulan: stt.bulan,
            hari: stt.hari,
            transdate: stt.transdate,
            subtotal: parseFloat(stt.subtotal),
            diskon: parseFloat(stt.diskon),
            proposal: stt.proposal,
            ppn: parseFloat(stt.ppn),
            total: parseFloat(stt.total),
            hpp: parseFloat(stt.hpp),
            harga_net: parseFloat(stt.harga_net),
            week: stt.week,
            number: stt.number,
            no_pajak: stt.no_pajak,
            berat: parseFloat(stt.berat),
            nopo: stt.nopo,
            status: stt.status,
            ordered_at: stt.ordered_at,
            approved_at: stt.approved_at,
            delivered_at: stt.delivered_at,
            tipe_pembayaran: stt.tipe_pembayaran,
            NamaPKP: stt.nama_pkp,
            AlamatPKP: stt.alamat_pkp,
            Principal: stt.principal,
            no_ktp: stt.no_ktp,
            nama_ktp: stt.nama_ktp,
            alamat_ktp: stt.alamat_ktp,
            order_qtydus: stt.order_qtydus,
            order_qtypcs: stt.order_qtypcs,
            pending_status: stt.pending_status,
            remark: stt.remark,
            id_perusahaan: stt.id_perusahaan,
            id_toko: stt.id_toko,
            id_salesman: stt.id_salesman,
            id_depo: stt.id_depo,
            id_barang: stt.id_barang,
            id_promo: stt.id_promo,
            tipe_toko_3: stt.tipe_toko_3,
            tipe_tim: stt.tipe_tim,
            due_date: stt.due_date,
            id_penjualan: stt.id_penjualan,
            tanggal_penjualan: stt.tanggal_penjualan,
          }));
          this.createExcel({ data: dataExcel, filename: `laporan-stt-me-${this.dataFilter.start_date} - ${this.dataFilter.end_date}` });
        })
        .catch((err) => {
          this.onError(err);
          this.isExportRequest = false;
        });
    },

    _import() {
      this.formImport.config = { view: true, title: "Import STT Enhanced" };
      this.formImport.data = null;

      this.formImport.action = (importData) => {
        this.axios.post("external_app/stt_enhanced/import", importData)
          .then((res) => {
            this._get({ silent: true });
            this.toast(res.data.message);
            this.formImport.config.view = false;
          })
          .catch((err) => {
            this.onError(err);
            this.formImport.isSubmit = false;
          });
      };
    },

    _deleteImport() {
      this.formDelete.config = { view: true, title: "Delete Bulk By Import ID" };
      this.formDelete.data = null;

      this.formDelete.action = (id) => {
        this.axios.delete("external_app/stt_enhanced/delete_by_import_id/"+id)
          .then((res) => {
            this._get({ silent: true });
            this.toast(res.data.message);
            this.formDelete.config.view = false;
          })
          .catch((err) => {
            this.onError(err);
            this.formDelete.isSubmit = false;
          });
      };
    },

    _delete(id) {
      this.confirm.id = id;
      this.confirm.title = "Yakin ingin menghapus data ini?";
      this.confirm.action = () => {
        this.axios
          .delete("external_app/stt_enhanced/" + id)
          .then(() => {
            this.toast("Berhasil dihapus");
            this._get({ silent: true });
            this.confirm.id = null;
          })
          .catch((err) => {
            this.onError(err);
            this.confirm.isSubmit = false;
          });
      };
    },

    _filter() {
      this.filter.config = { view: true, title: "Filter" };
      this.filter.action = (formData) => {
        this.isFilter = true;

        for (const key in formData) {
          this.dataFilter[key] = formData[key];
        }

        this._get();
      };
    },
  },

  mounted() {
    this._get();
  },
}
</script>